<div class='container'>
  <div class='row'>
    <div class='col col-4 offset-4'>
      <h4>Sending email for <b>{{ numberOfContacts }}</b> contacts...</h4>
    </div>
  </div>
  <div class='row'>
    <div class='col col-4 offset-4'>
      <mat-spinner></mat-spinner>
    </div>
  </div>
</div>